import styled from 'styled-components';
import { HelpText, IHelpTextProps } from '../HelpText/HelpText';

export interface IErrorTextProps extends Omit<IHelpTextProps, 'invalid'> {}

export const ErrorText = styled(HelpText).attrs<IErrorTextProps>((args) => ({
  ...args,
  invalid: true
}))``;
